<template>
  <modal :show.sync="visible" @update:show="handleModalClose">
    <div class="box">
      <div slot="header" class="force-logout-confirmation-header">
        {{ $t('users.forceLogoutConfirmTitle') }}
      </div>
      
      <div class="content force-logout-confirmation-content">
        <p class="force-logout-confirmation-message">
          {{ $t('users.forceLogoutConfirmMessage', { username: userName }) }}
        </p>
        <p class="force-logout-warning">
          {{ $t('users.forceLogoutWarning') }}
        </p>
      </div>

      <div slot="footer" class="field is-grouped is-grouped-right">
        <div class="control">
          <button 
            type="button" 
            class="button is-danger"
            @click="confirmForceLogout"
          >
            {{ $t('users.forceLogoutConfirmButton') }}
          </button>
        </div>
        <div class="control">
          <button 
            type="button" 
            class="button is-link is-light"
            @click="cancelForceLogout"
          >
            {{ $t('users.forceLogoutCancelButton') }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from '@cyradar/ui'

/**
 * ForceLogoutConfirmation Component
 * 
 * Displays a confirmation dialog before force logging out a user.
 */
export default {
  name: 'ForceLogoutConfirmation',
  components: {
    Modal
  },
  props: {
    /**
     * Controls the visibility of the confirmation dialog
     */
    show: {
      type: Boolean,
      default: false
    },
    /**
     * User object to be force logged out
     */
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    userName() {
      return this.user ? this.user.name : ''
    }
  },
  watch: {
    /**
     * Sync the internal visible state with the prop
     */
    show: {
      immediate: true,
      handler(newValue) {
        this.visible = newValue
      }
    }
  },
  methods: {
    /**
     * Handles the confirmation of force logout action
     */
    confirmForceLogout() {
      this.visible = false
      this.$emit('confirm')
    },

    /**
     * Handles the cancellation of force logout action
     */
    cancelForceLogout() {
      this.visible = false
      this.$emit('cancel')
    },

    /**
     * Handles modal close events (ESC key, click outside)
     */
    handleModalClose(value) {
      if (!value) {
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style scoped>
.force-logout-confirmation-header {
  font-size: 1.25rem;
  font-weight: 600;
}

.force-logout-confirmation-content {
  min-height: 100px;
  padding: 1.5rem 0;
}

.force-logout-confirmation-message {
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-weight: 500;
  color: #4a4a4a;
}

.force-logout-warning {
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 0;
  color: #ff3860;
  font-weight: 500;
}
</style>

